<template>
  <div>
    <ts-card>
      <div
        class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative"
      >
        <h4 class="ts-text-sm">
          {{ $t('user.pageTitle') }}
        </h4>
        <ts-modal-close-button />
      </div>
    </ts-card>
    <ts-card-wrapper>
      <form>
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group m-b-10">
              <label class="col-form-label control-label required">{{
                $t('user.warehouseLocation')
              }}</label>
              <div>
                <ts-loading-banner :loading="loadingPreData">
                  <treeselect
                    :options="
                      warehouses.map(i => ({
                        id: i.location_id,
                        label:
                          i.location_name +
                          (i.is_main_warehouse ? ' (Is Main)' : '')
                      }))
                    "
                    placeholder="Type for search..."
                    v-model="location_id"
                  ></treeselect>
                </ts-loading-banner>
                <div
                  class="invalid-feedback"
                  v-if="errors.has('delete_reason')"
                >
                  {{ errors.first('delete_reason') }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row ts-mt-6">
          <div class="col-sm-12 col-lg-12 col-md-12 text-right">
            <ts-button
              class="btn-sm"
              @click.prevent="$emit('close')"
              :disabled="saving"
              >{{ $t('no') }}</ts-button
            >
            <ts-button
              color="primary"
              class="ml-2 btn-sm"
              :waiting="saving"
              :disabled="!location_id"
              @click.prevent="yes"
              >{{ $t('yes') }}</ts-button
            >
          </div>
        </div>
      </form>
    </ts-card-wrapper>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions } from 'vuex'

export default {
  props: ['data'],
  name: 'chooseCashierLocation',
  data() {
    return {
      errors: new Errors(),
      loadingPreData: false,
      saving: false,
      warehouses: [],
      location_id: null
    }
  },
  created() {
    this.fetchLocation()
  },
  methods: {
    ...mapActions('user', ['getWarehouse']),
    fetchLocation() {
      this.loadingPreData = true
      this.getWarehouse({
        branch_id: [this.data.branch_id]
      })
        .then(response => {
          this.warehouses = response.data
          let main_warehouse = response.data.find(
            el => el.is_main_warehouse == true
          )
          this.location_id = main_warehouse ? main_warehouse.location_id : null
          this.loadingPreData = false
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.loadingPreData = false
        })
    },
    async yes() {
      this.saving = true
      await this.$store
        .dispatch('user/switchDefaultBranch', {
          branch_id: this.data.branch_id,
          location_id: this.location_id
        })
        .then(async response => {
          this.$Message.success({
            background: true,
            content: response.message
          })
          this.saving = false
          this.$emit('close')
          await this.fetchUser()
          const searchURL = new URL(window.location);
          if(searchURL.origin === this.data.company.system_url)
          {
            setTimeout(
              (window.location.href =
                this.data.company.system_url + this.$route.path),
              3000
            )
          }else{
            this.logout()
          }
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.saving = false
        })
    },
    async logout() {
      await this.$store.dispatch('logout')
      this.$router.push({ name: 'login' })
    },
    async fetchUser() {
      await this.$store
        .dispatch('user/getCurrentUser')
        .then(response => {
          if (response) {
            this.$store.commit('setAuthUser', {
              user_name: response.user_name,
              full_name: response.full_name,
              access_token: response.access_token,
              permission_allow_code: response.permission_allow_code,
              user_type: response.user_type,
              guardian_type_id: response.guardian_type_id,
              permissions: response.permissions,
              default_branch: response.default_branch,
              default_branch_id: response.default_branch_id,
              user_profile: response.user_profile,
              cashier_location_id: response.cashier_location_id,
              children: response.children,
              company: response.company,
              is_external: response.is_external,
              menu_favorites: response.menu_favorites, //set menu_favorites by response
              
            })
          }
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    }
  }
}
</script>
